module.exports = __webpack_public_path__ + "img/8049b4f.jpg";